<custom-arena
  #customArena
  [navigationItems]="navigation"
  [menuOpened]="isSidebarOpen"
  [logoIcon]="logoIcon"
  [logoMiniatureIcon]="logoMiniatureIcon"
  [updateToolBarTitles]="false"
  [currentUserName]="dataService.currentUserName"
  [userAvatar]="dataService.userAvatar"
  [showNavigationBorder]="false"
  [showToggleButton]="false"
  [userMessage]="false"
  [userNotification]="false"
  [showMenuToggleButton]="true"
  [showMobileToggleIcon]="showMobileToggleIcon"
  [userFunction]="dataService.getRole()"
  [contextMenuAdditionalItems]="contextMenuItems"
  [defaultAvatar]="'assets/images/profileAvatar.svg'"
  (onNavigationItemClick)="onNavigationItemClick($event)"
  (getLoginInfo)="getLoginInfo($event)"
  (menuToggle)="menuToggle($event)"
>
  <div toolBarFirstTitle class="header-breadcrumb-wrapper">
    <div class="breadcrumb-row primary-row">
      <span class="clickable-text" (click)="redirectToCompanyList()">
        {{ companyName }}
      </span>

      @if (projectName()) {
        <i class="dx-icon-chevronright separator-icon"></i>
        <span class="clickable-text" (click)="redirectToProjectList()">
          {{ projectName() }}
        </span>
      }
    </div>

    @if (measureName()) {
      <div toolBarSecondTitle class="breadcrumb-row secondary-row">
        <span class="label-text">
          {{ subProjectName() }}
        </span>

        <i class="dx-icon-chevronright separator-icon"></i>

        <span class="measure-text">
          {{ measureName() }}
        </span>
      </div>
    }
  </div>

  <div
    headerIcons
    class="circular-background notification-style"
    (click)="openNotificationPopup()"
  >
    @if (unreadNotificationsCount() > 0) {
      <div class="notification-count">
        <span class="flex-number">
          <span
            [ngClass]="{ 'flex-number-text': unreadNotificationsCount() > 99 }"
            >{{
              unreadNotificationsCount() > 99
                ? "99"
                : unreadNotificationsCount()
            }}</span
          >
          @if (unreadNotificationsCount() > 99) {
            <span class="superscript">+</span>
          }
        </span>
      </div>
    }
    <img
      id="notification"
      class="notification-icon"
      [src]="
        unreadNotificationsCount() > 0
          ? 'assets/images/notification-active.svg'
          : 'assets/images/notification-inactive.svg'
      "
      alt="Notification Active"
    />
  </div>

  <div headerIcons class="circular-background">
    <img
      class="favorite-icon"
      (click)="openFavoriteSideBar()"
      src="assets/images/Favorit.svg"
    />
  </div>
  @if (companyName && projectName()) {
    <div headerIcons class="circular-background">
      <img
        class="contact-icon"
        src="assets/images/Kontakt.svg"
        (click)="openSupportPopup()"
      />
    </div>
  }
  <div [ngClass]="{ 'is-loading': isLoading }" class="content-container">
    <router-outlet></router-outlet>
  </div>
  @if (isLoading) {
    <div
      class="loader-container"
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      <ubt-loader></ubt-loader>
    </div>
  }
  @if (isFavoriteOpen) {
    <ubt-geods-favorite-list #favorites (closebtn)="closeFavorites()">
    </ubt-geods-favorite-list>
  }
</custom-arena>
<abc-toast
  #toast
  [animation]="toastAnimation"
  [type]="'custom'"
  width="auto"
  [position]="toastPosition"
  [contentTemplate]="toastTemplate"
>
  <div *dxTemplate="let data of 'success'" class="successful-toast-style">
    <div>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
  <div *dxTemplate="let data of 'error'" class="failure-toast-style">
    <div>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
  <div *dxTemplate="let data of 'info'" class="info-toast-style">
    <div>
      <p>{{ toastMessage }}</p>
    </div>
  </div>
</abc-toast>
<abc-popup
  #resetPasswordPopUp
  class="popup-style settings-popup"
  [height]="'60%'"
  [maxHeight]="'850px'"
  [minHeight]="'600px'"
  [minWidth]="'300px'"
  fxLayout="column"
  fxLayoutAlign="center center"
  [title]="dataService.res('Ubt-Menu-Settings')"
  [showCloseButton]="true"
  [fullScreen]="settingsPopupFullScreenMode"
>
  <div class="settings-card">
    <abc-tab-panel
      #settingsTabPanel
      width="100%"
      height="100%"
      [animationEnabled]="true"
      [swipeEnabled]="true"
      [dataSource]="settingsTabs"
      tabsPosition="left"
      stylingMode="primary"
      iconPosition="start"
      class="custom-settings-panel"
    >
      <div *dxTemplate="let tab of 'title'" class="tab-header-item">
        <i class="dx-icon-{{ tab.icon }}"></i>
        <span class="tab-title-text">{{ tab.title }}</span>
      </div>

      <div *dxTemplate="let tab of 'item'">
        <div class="tab-inner-content">
          <div *ngIf="tab.id === 0" class="fade-in">
            <div class="section-header">
              <h3>{{ dataService.res("notification.settings-Title") }}</h3>
              <p>{{ dataService.res("notification.settings-SubTitle") }}</p>
            </div>

            <div class="options-grid">
              <div class="option-item">
                <dx-switch
                  #switch
                  [(value)]="notificationByEmail"
                  (onValueChanged)="
                    persistNotificationSettings(
                      NotificationSettingsTypes.EMAIL,
                      notificationByEmail,
                      emailNotificationSettingProperty?.Id
                    )
                  "
                ></dx-switch>
                <span class="option-description">{{
                  dataService.res(
                    "notification.settings-emailNotification-label"
                  )
                }}</span>
              </div>
              <div class="option-item">
                <dx-switch
                  #switch
                  [(value)]="notificationInApp"
                  (onValueChanged)="
                    persistNotificationSettings(
                      NotificationSettingsTypes.INAPP,
                      notificationInApp,
                      inAppNotificationSettingProperty?.Id
                    )
                  "
                ></dx-switch>
                <span class="option-description">{{
                  dataService.res(
                    "notification.settings-inAppNotification-label"
                  )
                }}</span>
              </div>
              <div class="option-item">
                <abc-select-box
                  [items]="languageOptions"
                  [(value)]="selectedLanguage"
                  valueExpr="value"
                  displayExpr="text"
                  (onValueChanged)="
                    persistNotificationSettings(
                      NotificationSettingsTypes.EMAIL,
                      notificationByEmail,
                      emailNotificationSettingProperty?.Id,
                      selectedLanguage
                    )
                  "
                ></abc-select-box>
                <span class="option-description">
                  notificatiion email language
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="tab.id === 1" class="fade-in">
            <div class="section-header">
              <h3>{{ dataService.res("security.settings-Title") }}</h3>
              <p>{{ dataService.res("security.settings-SubTitle") }}</p>
            </div>
            <abc-management-users-user-settings
              (changedEvent)="afterPasswordReset()"
            >
            </abc-management-users-user-settings>
          </div>
        </div>
      </div>
    </abc-tab-panel>
  </div>
</abc-popup>
<support-mail-popup #supportMailPopup></support-mail-popup>
<notification-popup #notificationPopup></notification-popup>
